var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"buyNft_view"},[_c('MenuNft'),_c('BuyNftView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }